{
	"overview": "Overview",
	"assureSavings": "Assure carbon reductions",
	"productAllocation": "Product allocation"
}
